import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

export default function AppSelectInput({ list, selected, onChange, className }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(selected);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setSelectedItem(selected);
  }, [selected]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (item, event) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedItem(item);
    setIsOpen(false);
    if (onChange) {
      onChange(item.id);
    }
  };

  return (
    <div className={`select ${isOpen ? "active" : ""}`} ref={wrapperRef}>
      <div
        className={`select__selected  ${className || ""}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        {selectedItem ? selectedItem.value : "Select an option"}
        <ChevronDown color="#15803d" size={20} />
      </div>
      <ul 
        className={`select__options ${isOpen ? "active" : ""}`}
        style={{
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          backgroundColor: "white",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          padding: "4px",
          marginTop: "18px",
        }}
      >
        {list.map((item, index) => (
          <li
            key={index}
            className="select__option"
            onClick={(e) => handleSelect(item, e)}
            style={{
              padding: "8px 12px",
              borderRadius: "8px",
              margin: "2px 0",
              cursor: "pointer",
              fontSize: "14px",
              color: "#334155",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#ecfdf5";
              e.target.style.color = "#047857";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "#334155";
            }}
          >
            {item.value}
          </li>
        ))}
      </ul>
    </div>
  );
}